import { reduxKey } from './constants';
import { reduxModuleLoaded } from './actions/editor';
import { moduleLoadableSaga } from './sagas';
import reducers from './reducers';
export function getEditorModule() {
    return {
        id: 'editorModule',
        reducerMap: {
            [reduxKey]: reducers
        },
        sagas: [
            moduleLoadableSaga
        ],
        retained: false,
        initialActions: [
            reduxModuleLoaded()
        ]
    };
}

//# sourceMappingURL=module.js.map